<template>
  <modal titulo="Retificar Selo - Complemento de Depósito Prévio" id="retificar-selo-deposito-previo">

    <card>
      <div v-if="selo.codigo">Código: {{ selo.codigo }}<template v-if="selo.codigoValidador">-{{selo.codigoValidador}}</template></div>
      <div class="mt-2" v-if="selo.utilizacao">Data de Utilização: {{selo.utilizacao | datahora}}</div>
    </card>

    <card class="mt-4">
      <card-content>
        <div class="row">
          <div class="col">
            <v-input label="Valor do Depósito" v-model="form.valorProtocoloFinanceiro" type="currency" :error="validation.valorProtocoloFinanceiro" />
          </div>
        </div>
      </card-content>
    </card>

    <template #footer>
      <button type="button" @click.prevent="close()" class="btn btn-outline-secondary mr-auto">Fechar</button>
      <v-button :run="retificarSelo" class="btn-outline-primary" :popover="true">Retificar Selo</v-button>
    </template>

  </modal>
</template>

<script>
  import FrontBusiness from "@/business/FrontBusiness.js";
  import SeloBusiness from "@/business/SeloBusiness.js";
  import Card from "@/components/Layout/components/Card.vue";
  import CardContent from "@/components/Layout/components/CardContent.vue";
  import Modal from "@/components/Modal";

  export default {
    name: "ModalRetificarSeloDepositoPrevio",
    components: {Card, CardContent, Modal},

    props: {
      selo: Object
    },

    data() {
      return {
        validation: {},
        form: {
          valorProtocoloFinanceiro: this.selo?.valorProtocoloFinanceiro || 0
        }
      }
    },

    methods: {

      close(response) {
        FrontBusiness.closeModal(response);
      },

      async retificarSelo() {
        this.$set(this, 'validation', {});

        if (!this.form.valorProtocoloFinanceiro || this.form.valorProtocoloFinanceiro <= 0) {
          this.$set(this.validation, 'valorProtocoloFinanceiro', 'Campo obrigatório');
          return;
        }

        try {
          await SeloBusiness.retificarSeloFinanceiro(this.selo.id, this.form);
          FrontBusiness.showSuccess('', 'Selo retificado com sucesso!');
          this.close(true);
        } catch (e) {
          FrontBusiness.showError('Erro ao retificar selo', e?.message);
        }
      }

    }
  }
</script>
